<template>
  <div id="page-supliers-list">
    <div class="vx-card p-6">
      <vs-table
        id="table-loading"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        pagination
        :max-items="this.length"
        search
        :data="products"
      >
        <!-- table header -->
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div
              @click="$router.push('/products/create')"
              v-if="checkPermissionByIds([permissions.PRODUCT_ADD])"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Product</span>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="paroduct.id">Sr#</vs-th>
          <vs-th sort-key="product.product_name">Strain Name</vs-th>
          <vs-th sort-key="product.weight_type">Weight Type</vs-th>
          <vs-th sort-key="product.weight_per_package">Weight per Package </vs-th>
          <vs-th sort-key="product.quantity">Quantity</vs-th>
          <vs-th sort-key="category.category_name">Category</vs-th>
          <vs-th sort-key="batch.batch_number">Batch Serial No#</vs-th>
          <vs-th v-if="isGrowersAndProcessors && checkPermissionByIds([permissions.MARKET_PLACE_ADD])">Available In Marketplace</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ tr.product_name }}
            </vs-td>
            <vs-td>
              {{ tr.weight_type }}
            </vs-td>
            <vs-td>
              {{ mathRound([categories.FLOWER, categories.SHAKE].includes(tr.categoryId) ? tr.quantity : tr.weight_per_package, 3) }}
            </vs-td>
            <vs-td>
              {{ [categories.FLOWER, categories.SHAKE].includes(tr.categoryId) ? '-' : mathRound(tr.quantity, 3) }}
            </vs-td>
            <vs-td>
              {{ tr.category && tr.category.category_name }}
            </vs-td>
            <vs-td>
              {{ tr.batch && tr.batch.batch_number }}
            </vs-td>
            <vs-td v-if="isGrowersAndProcessors && checkPermissionByIds([permissions.MARKET_PLACE_ADD])">
              <vs-switch color="primary" :value="tr.show_in_marketplace" @input="updateStatus(tr.id, !tr.show_in_marketplace)">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </vs-td>
            <vs-td>
              <vs-dropdown
                vs-trigger-click
                class="cursor-pointer"
                v-if="checkPermissionByIds([permissions.PRODUCT_EDIT, permissions.PRODUCT_VIEW, permissions.PRODUCT_DELETE, permissions.PRODUCT_PRINT_LABEL])"
              >
                <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                  Actions
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu class="products__actions">
                  <vs-dropdown-item v-if="checkPermissionByIds([permissions.PRODUCT_PRINT_LABEL])" @click="sendToLabelPage(tr)">
                    <feather-icon icon="TagIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Print Label
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkPermissionByIds([permissions.PRODUCT_PRINT_LABEL])" @click="generateBarcode(tr)">
                    <feather-icon icon="BarChart2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Barcode
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkPermissionByIds([permissions.PRODUCT_EDIT]) && ![categories.PLANT, categories.MATURE].includes(tr.categoryId)" @click="togglePackageQtyUpdateModal(tr)">
                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Update Quantity
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkPermissionByIds([permissions.PRODUCT_EDIT])" @click="sendToEditPage(tr.id)">
                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Edit Product
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkPermissionByIds([permissions.PRODUCT_DELETE])" @click="deleteRecord(tr.id)">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" /> Delete Product
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <div v-else>-</div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- update package qty modal -->
    <update-package-qty
      v-if="isUpdatePackageQtyModalMounted"
      :isUpdatePackageQtyModalShow.sync="isUpdatePackageQtyModalShow"
      :productId="selectedItem.id"
      :weightType="selectedItem.weight_type"
      :updatePackageQty="updatePackageQty"
      @done="getData"
    />

    <!-- download barcode -->
    <download-bar-code v-if="isDownloadBarCodeModalMounted" :isDownloadBarCodeModalShow.sync="isDownloadBarCodeModalShow" :product="selectedProduct" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { weightMixins } from '@/utils/weightType'

import DownloadBarCode from '@/views/products/components/DownloadBarcodeModal.vue'
import UpdatePackageQty from './components/UpdatePackageQty.vue' // update product qty modal

export default {
  name: 'ProductList',

  components: {
    DownloadBarCode,
    UpdatePackageQty // update package qty modal
  },

  data: () => ({
    order: [],
    length: 10,
    page: 1,
    search: '',
    activePrompt: false,
    quantity: 0,
    id: 0,
    processing: false,

    // update quantity modal
    isUpdatePackageQtyModalMounted: false,
    isUpdatePackageQtyModalShow: false,

    // download barcode modal stat
    isDownloadBarCodeModalMounted: false,
    isDownloadBarCodeModalShow: false,
    selectedProduct: null
  }),

  mixins: [weightMixins],

  mounted() {
    this.getData()
  },

  computed: {
    ...mapState('permission', ['permissions', 'roles']),
    ...mapState('product', { products: 'products', total: 'total', FilteredCount: 'FilteredCount', loading: 'loading', categories: 'categories' }),
    ...mapState('auth', ['user', 'growerAndProcessorRoleGroup']),
    ...mapGetters('auth', ['checkPermissionByIds']),

    growersAndProcessors() {
      return this.growerAndProcessorRoleGroup
    },

    isGrowersAndProcessors() {
      return this.growersAndProcessors.includes(this.user.role.id)
    },

    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    ...mapActions('product', { getProductList: 'getProductList', quantityEdit: 'quantityEdit', updateProductStatus: 'updateProductStatus', deleteProductRecord: 'deleteProduct' }),

    getData() {
      const { order, length, page, search } = this
      this.getProductList({
        order,
        limit: length,
        page,
        search
      })
    },

    sendToLabelPage(tr) {
      this.$router.push({ name: 'product-label', params: { id: tr.id } })
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteProduct(id),
        acceptText: 'Delete'
      })
    },

    async deleteProduct(id) {
      try {
        await this.deleteProductRecord(id)
        if (this.products.length === 1 && this.page !== 1) {
          this.page -= 1
        }
        this.$vs.notify({
          title: 'Success',
          text: 'Product deleted successfully!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    sendToEditPage(id) {
      this.$router.push({
        name: 'edit-product',
        params: {
          id
        }
      })
    },

    sendToHistoricalList(id) {
      this.$router.push({
        name: 'edit-product-historical-change',
        params: {
          id
        }
      })
    },

    // toggle update package qty modal
    togglePackageQtyUpdateModal(data) {
      this.selectedItem = data
      this.updatePackageQty = data
      this.isUpdatePackageQtyModalMounted = true
      this.isUpdatePackageQtyModalShow = true
    },

    async saveQuantity() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fill the Quantity',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      this.activePrompt = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: 'Are you sure you want to save this record?',
        acceptText: 'Yes, I am sure!',
        cancelText: 'No, cancel it!',
        accept: await this.updateQty,
        cancel: () => {
          this.activePrompt = true
        }
      })
    },

    // update quantity
    async updateQty() {
      try {
        this.processing = true
        const { message } = await this.quantityEdit({
          id: this.id,
          data: {
            quantity: this.quantity
          }
        })
        this.processing = false
        this.activePrompt = false
        this.quantity = 0
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.processing = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    async updateStatus(id, status) {
      try {
        const { message } = await this.updateProductStatus({
          id,
          status
        })

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getData()
      } catch (err) {
        const { message } = err
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // generate barcode
    generateBarcode(tr) {
      this.isDownloadBarCodeModalMounted = true
      this.isDownloadBarCodeModalShow = true
      this.selectedProduct = tr
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#table-loading',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#table-loading > .con-vs-loading')
      }
    },

    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#update-product-quantity-popup',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-product-quantity-popup > .con-vs-loading')
      }
    },

    // handle callback for update package
    isUpdatePackageQtyModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isUpdatePackageQtyModalMounted = false
            this.selectedItem = null
          }, 0)
        }
      }
    },

    isDownloadBarCodeModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isDownloadBarCodeModalMounted = false
            this.selectedProduct = null
          }, 0)
        }
      }
    }
  },
  created() {
    this.$validator.extend('not_zero', {
      getMessage: (field) => `${field} can't be zero.`,
      validate: (value) => value !== 0
    })
  },

  beforeRouteLeave(_, __, next) {
    this.activePrompt = false
    this.isDownloadBarCodeModalShow = false
    next()
  }
}
</script>

<style lang="scss">
.products__actions {
  width: 220px;

  li {
    padding: 5px;
    a {
      display: flex !important;
      align-items: center;
    }
  }
}
</style>
